import type { AppSettings, Screensaver } from '../types';

type WebViewEvent = {
  type: string;
}

type OpenWebViewEvent = {
  url: string;
  textClose?: string;
} & WebViewEvent;

type ConsoleLogEvent = {
  msg?: string;
} & WebViewEvent;

type AppSettingsEvent = AppSettings & WebViewEvent;

type ChangeSectionEvent = {
  path: string;
} & WebViewEvent;

type SetScreensaversEvent = {
  screensavers: Screensaver[];
} & WebViewEvent;

type CardClickEvent = {
  cardId: string;
  cardTitle: string;
  cardType: string;
  cardLink: string;
} & WebViewEvent;

type LogEvent = {
  eventId: string;
  eventName: string;
  eventType?: string;
  eventText: string;
  eventIntent?: string;
} & WebViewEvent;

export const openWebView = (url:string, textClose?:string) => {
  const openWebViewEvent: OpenWebViewEvent = {
    type: 'openModalUrl',
    url,
    textClose
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(openWebViewEvent));
};

export const saveAppSettings = (appSettings: AppSettings) => {
  const appSettingsEvent: AppSettingsEvent = {
    type: 'saveSettingsData',
    ...appSettings
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(appSettingsEvent));
};

export const resetAppSettings = () => {
  const resetEvent:WebViewEvent = {
    type: 'resetSettingsData'
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(resetEvent));
};

export const checkForUpdate = () => {
  const checkForUpdate: WebViewEvent = {
    type: 'checkForUpdateApp'
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(checkForUpdate));
};

export const onChangeSection = (path:string) => {
  const changeSection:ChangeSectionEvent = {
    type: 'onChangeSection',
    path
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(changeSection));
};

export const setScreensavers = (screensavers:Screensaver[]) => {
  const screensaversEvent:SetScreensaversEvent = {
    type: 'setScreensavers',
    screensavers
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(screensaversEvent));
};

export const reloadWebView = () => {
  const reloadEvent:WebViewEvent = {
    type: 'reloadWebView'
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(reloadEvent));
};

export const logCardClick = (id:string, title:string, type:string, link:string) => {
  const cardEvent:CardClickEvent = {
    type: 'cardClick',
    cardId: id,
    cardTitle: title,
    cardType: type,
    cardLink: link,
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(cardEvent));
};

export const logClickEvent = (id:string ,name:string, type:string, text:string, intent?:string) => {
  const event:LogEvent = {
    type: 'logClickEvent',
    eventId: id,
    eventName: name,
    eventType: type,
    eventText: text,
    eventIntent: intent,
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(event));
};

export const consoleLog = (msg:string) => {
  const event:ConsoleLogEvent ={
    type: 'consoleLog',
    msg
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(event));
};
